module.exports.config = {
  declarative: true,
  "render-module": {
    name: "PieceFinalCountdownRenderModule",
    path: "front/piece-final-countdown-render.module"
  },
  "cms-module": {
    name: "PieceFinalCountdownCmsModule",
    path: "front/piece-final-countdown-cms.module"
  },
  definition: {
    type: "finalCountdown",
    name: "PieceFinalCountdownDefinition",
    group: "Components",
    availablePlatforms: ["web", "apps"],
    description: "Cuenta atrás",
    isNew: true,
    fields: [
      {
        name: "startDate",
        label: "Fecha inicio",
        type: "datetime",
        mandatory: true
      },
      {
        name: "endDate",
        label: "Fecha fin",
        type: "datetime",
        mandatory: true
      },
      {
        name: "typeOfDate",
        label: "Tipo de fecha",
        type: "options",
        defaultValue: "local",
        values: [
          {
            label: "Local",
            value: "local"
          },
          {
            label: "UTC",
            value: "utc",
          }
        ]
      },
      {
        name: "dateStyle",
        label: "Estilo de fecha",
        type: "groupCollapsable",
        fields: [
          {
            name: "dateStyleTabs",
            type: "groupTabs",
            flattenFields: true,
            tabs: [
              {
                label: "Dias",
                fields: ["showDays"]
              },
              {
                label: "Horas",
                fields: ["showHours"]
              },
              {
                label: "Minutos",
                fields: ["showMinutes"]
              },
              {
                label: "Segundos",
                fields: ["showSeconds"]
              }
            ],
            fields: [
              {
                name: "showDays",
                label: "Mostrar días",
                type: "groupToggleable",
                flattenFields: true,
                defaultValue: true,
                fields: [
                  {
                    name: "daysTextFormat",
                    label: "Días",
                    type: "richText",
                    mandatory: true,
                    defaultValue: "<p><span data-entity='placeholder'>{{dateDay}}</span></p>"
                  }
                ]
              },
              {
                name: "showHours",
                label: "Mostrar horas",
                type: "groupToggleable",
                flattenFields: true,
                defaultValue: true,
                fields: [
                  {
                    name: "hoursTextFormat",
                    label: "Horas",
                    type: "richText",
                    mandatory: true,
                    defaultValue: "<p><span data-entity='placeholder'>{{dateHour}}</span></p>"
                  }
                ]
              },
              {
                name: "showMinutes",
                label: "Mostrar minutos",
                type: "groupToggleable",
                flattenFields: true,
                defaultValue: true,
                fields: [
                  {
                    name: "minutesTextFormat",
                    label: "Minutos",
                    type: "richText",
                    mandatory: true,
                    defaultValue: "<p><span data-entity='placeholder'>{{dateMinute}}</span></p>"
                  }
                ]
              },
              {
                name: "showSeconds",
                label: "Mostrar segundos",
                type: "groupToggleable",
                flattenFields: true,
                defaultValue: true,
                fields: [
                  {
                    name: "secondsTextFormat",
                    label: "Segundos",
                    type: "richText",
                    mandatory: true,
                    defaultValue: "<p><span data-entity='placeholder'>{{dateSecond}}</span></p>"
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        name: "labelStyle",
        label: "Estilo de etiquetas",
        type: "groupCollapsable",
        fields: [
          {
            name: "showLabel",
            label: "Mostrar etiquetas",
            type: "groupToggleable",
            flattenFields: true,
            defaultValue: false,
            fields: [
              {
                name: "labelStyleTabs",
                type: "groupTabs",
                flattenFields: true,
                tabs: [
                  {
                    label: "Dias",
                    fields: ["showDays"]
                  },
                  {
                    label: "Horas",
                    fields: ["showHours"]
                  },
                  {
                    label: "Minutos",
                    fields: ["showMinutes"]
                  },
                  {
                    label: "Segundos",
                    fields: ["showSeconds"]
                  }
                ],
                fields: [
                  {
                    name: "showDays",
                    label: "Mostrar días",
                    type: "groupToggleable",
                    flattenFields: true,
                    defaultValue: false,
                    fields: [
                      {
                        name: "daysTextFormat",
                        label: "Días",
                        type: "richText",
                        mandatory: true
                      },
                      {
                        name: "labelDayPadding",
                        label: "Padding al texto",
                        type: "linkedUnits",
                        jsonPath: "labelStyle.labelDayPadding.padding",
                      }
                    ]
                  },
                  {
                    name: "showHours",
                    label: "Mostrar horas",
                    type: "groupToggleable",
                    flattenFields: true,
                    defaultValue: false,
                    fields: [
                      {
                        name: "hoursTextFormat",
                        label: "Horas",
                        type: "richText",
                        mandatory: true
                      },
                      {
                        name: "labelHourPadding",
                        label: "Padding al texto",
                        type: "linkedUnits",
                        jsonPath: "labelStyle.labelHourPadding.padding",
                      }
                    ]
                  },
                  {
                    name: "showMinutes",
                    label: "Mostrar minutos",
                    type: "groupToggleable",
                    flattenFields: true,
                    defaultValue: false,
                    fields: [
                      {
                        name: "minutesTextFormat",
                        label: "Minutos",
                        type: "richText",
                        mandatory: true
                      },
                      {
                        name: "labelMinutePadding",
                        label: "Padding al texto",
                        type: "linkedUnits",
                        jsonPath: "labelStyle.labelMinutePadding.padding",
                      }
                    ]
                  },
                  {
                    name: "showSeconds",
                    label: "Mostrar segundos",
                    type: "groupToggleable",
                    flattenFields: true,
                    defaultValue: false,
                    fields: [
                      {
                        name: "secondsTextFormat",
                        label: "Segundos",
                        type: "richText",
                        mandatory: true
                      },
                      {
                        name: "labelSecondPadding",
                        label: "Padding al texto",
                        type: "linkedUnits",
                        jsonPath: "labelStyle.labelSecondPadding.padding",
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        name: "finalCounterText",
        label: "Texto final contador",
        type: "groupCollapsable",
        fields: [
          {
            name: "showText",
            label: "Mostrar texto final contador",
            type: "groupToggleable",
            flattenFields: true,
            fields: [
              {
                name: "text",
                label: "Texto",
                type: "richText",
                mandatory: true
              },
              {
                name: "finalCounterTextPadding",
                label: "Padding al texto",
                type: "linkedUnits",
                jsonPath: "finalCounterText.padding",
              }
            ]
          }
        ]
      },
      {
        name: "progressBar",
        label: "Barra de progreso",
        type: "groupCollapsable",
        fields: [
          {
            name: "showProgressBar",
            label: "Mostrar barra de progreso",
            type: "groupToggleable",
            flattenFields: true,
            fields: [
              {
                name: "width",
                label: "Grosor",
                type: "units",
                defaultValue: "2px",
                disableUnits: ['%', 'vw', 'vh']
              },
              {
                name: "foregroundColor",
                label: "Color barra de progreso",
                type: "color"
              },
              {
                name: "backgroundColor",
                label: "Color fondo",
                type: "color"
              },
            ]
          }
        ]
      },
      {
        name: "helperNextEvent",
        label: "Helper próximo evento",
        type: "groupCollapsable",
        fields: [
          {
            name:"nearestPromotionEvent",
            label:"Obtener las fechas de la próxima promoción",
            type:"boolean",
          },
          {
            name:"endDateNextPromotionEvent",
            label:"Utilizar la fecha de fin de la próxima promoción",
            type:"boolean",
          }
        ]
      },
      {
        name: "theme",
        label: "Aspecto de la tabla",
        type: "options",
        section: "styles",
        defaultValue: "default",
        values: [
          { label: "Por defecto", value: "default" },
          { label: "Cajas", value: "box" },
          {
            label: "Clases personalizadas",
            value: "customClasses",
            shouldDisplayWhenSelected: "customClassesList",
            jsonPath: "styles.customClassesList"
          }
        ]
      }
    ]
  }
};
